export default "__VITE_ASSET__CPob4jow__"